import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["checked", "disabled", "id", "forwardedRef", "name", "onCheckedChange"];
import React from "react";
import CheckedIcon from "../CheckedIcon";
import IndeterminateIcon from "../IndeterminateIcon";
import { BaseCheckboxIndicator, BaseCheckboxRoot } from "./styled";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export default function BaseCheckbox(_ref) {
  var checked = _ref.checked,
    disabled = _ref.disabled,
    id = _ref.id,
    forwardedRef = _ref.forwardedRef,
    name = _ref.name,
    onCheckedChange = _ref.onCheckedChange,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/_jsx(BaseCheckboxRoot, _extends({
    checked: checked,
    disabled: disabled,
    id: id,
    ref: forwardedRef,
    name: name,
    onCheckedChange: onCheckedChange
  }, props, {
    children: /*#__PURE__*/_jsxs(BaseCheckboxIndicator, {
      children: [checked === "indeterminate" && /*#__PURE__*/_jsx(IndeterminateIcon, {}), checked === true && /*#__PURE__*/_jsx(CheckedIcon, {})]
    })
  }));
}